import React from 'react';
import PropTypes from 'prop-types';

import ColorUtils from '../../utils/colorUtils';
import './style.scss';

class TabMenu extends React.Component {

	static propTypes = {
		background: PropTypes.string,
	};
	
	static defaultProps = {
		background: '#fff',
	};
	
	componentDidMount () {
		this.leftGradient.style.opacity = 0;
		this.rightGradient.style.opacity = 0;
		const { r, g, b } = ColorUtils.hexToRgb(this.props.background);
		// console.log('bgColor', this.props.background, r, g, b);
		this.leftGradient.style.background = `linear-gradient(to right, rgba(${r}, ${g}, ${g}, 0.9) 0%, rgba(${r}, ${g}, ${g}, 0) 100%)`;
		this.rightGradient.style.background = `linear-gradient(to left, rgba(${r}, ${g}, ${g}, 0.9) 0%, rgba(${r}, ${g}, ${g}, 0) 100%)`;
		// console.log(this.leftGradient.style.background, this.rightGradient.style.background);
	}

	handleScroll (e) {
		const leftX = e.target.scrollLeft;
		const width = e.target.clientWidth;
		const rightX = this.tabsContainer.scrollWidth - width - leftX;
		// console.log('handleScroll:', leftX, rightX, width, this.tabsContainer.scrollWidth);
		this.leftGradient.style.opacity = Math.min(leftX, this.leftGradient.offsetWidth) / this.leftGradient.offsetWidth;
		this.rightGradient.style.opacity = Math.min(rightX, this.rightGradient.offsetWidth) / this.rightGradient.offsetWidth;
	}

	render () {
		return (
			<div className="tab-menu" ref={node => this.node = node} onScroll={e => this.handleScroll(e)}>
				<div className="tabs" ref={node => this.tabsContainer = node}>
					{this.props.children}
				</div>
				<div className="gradient-left" ref={node => this.leftGradient = node} />
				<div className="gradient-right" ref={node => this.rightGradient = node} />
			</div>
		);
	}
}

export default TabMenu;
